import React from 'react';
import useSearchStore from '../../_Global/SearchStore';

interface FacetTabConfiguration {
    facetTitle: string;
    facetKey: string;
    isActive: boolean;
    facetParamName: string;
    onToggle(string): void;
}

function FacetTab({facetTitle, facetKey, isActive, facetParamName, onToggle}: FacetTabConfiguration) {
    const searchFacetsJson = useSearchStore((state) => state.getSearchFacetDataByKey(facetKey));
    const selectedFacetsJson = useSearchStore((state) => state.getSearchFacetSelectionsByKey(facetParamName));

    /**
     * Respond to clicks on the tab button
     */
    const onTabClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.preventDefault();

        onToggle(isActive ? '' : facetTitle);
    };

    return (
        <button
            id={`filter-tab-${facetTitle.replace(/\s/, '-')}`}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-controls={`filter-${facetTitle.replace(/\s/, '-')}-panel`}
            className={`button button--tab body-size-xl${isActive ? ' button--active' : ''}`}
            aria-expanded={isActive}
            onClick={onTabClick}
            disabled={searchFacetsJson.length === 0}
        >
            <div className={`icon__expand-container${isActive ? ' icon__expand--active' : ''}`}>
                <svg className="icon__expand-horizontal">
                    <use xlinkHref="#minus"></use>
                </svg>
                <svg className="icon__expand-vertical">
                    <use xlinkHref="#minus"></use>
                </svg>
            </div>
            <span className="button__label">{facetTitle}{ selectedFacetsJson.length !== 0 ? ` (${selectedFacetsJson.length})` : null}</span>
        </button>
    );
}

export default React.memo(FacetTab);
